/* eslint-disable max-len */
import React from 'react'

const ActionErrorToastMessage = ({message}) => {
    return (
        <div class="mx-auto absolute top-1.5 right-[60px] pb-3 flex items-center min-w-[321px] justify-center shadow-s2 rounded-lg data-[te-alert-show]:inline-flex z-[100]" role="alert" data-te-alert-init data-te-alert-dismiss aria-label="Close">
            <div class="flex items-center justify-start border-[1.5px] border-[#F04438] bg-[#FFD6D3] rounded-[7px] cursor-pointer px-5 py-[18px]">
                <span>
                    <img loading="lazy" decoding="async" src="/images/error-icon.svg" alt="icon" />
                </span>
                <p class="text-f1 text-[#000000] font-normal pl-5">{message}</p>
            </div>
        </div>
    )
}

export default ActionErrorToastMessage